import { Component } from '@angular/core';

@Component({
  selector: 'app-freight-manager',
  templateUrl: './freight-manager.component.html',
  styleUrls: ['./freight-manager.component.scss']
})
export class FreightManagerComponent {

}
